import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const fetchAllUOMs = (filters = {}) => {
  return new Promise((resolve, reject) => {
    filters.itemuom = filters.itemuom || "";
    filters.itembasicuom = filters.itembasicuom || "";
    const query_string = new URLSearchParams(filters).toString();
    
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/uom?${query_string}`, {
        headers: authHeader(),
      })
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const fetchOneUOM = (id) => {
  return new Promise((resolve, reject) => {
    if (!id) return resolve(null);

    axios
      .get(`${process.env.REACT_APP_BASE_URL}/uom/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const createUOM = (data) => {
  return new Promise((resolve, reject) => {
    if (!data) return resolve(null);

    axios
      .post(`${process.env.REACT_APP_BASE_URL}/uom/`, data, {
        headers: authHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const updateUOM = ({ id, data }) => {
  return new Promise((resolve, reject) => {
    if (!id || !data) return resolve(null);

    axios
      .put(`${process.env.REACT_APP_BASE_URL}/uom/${id}`, data, {
        headers: authHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const deleteUOM = (id) => {
  return new Promise((resolve, reject) => {
    if (!id) return resolve(null);

    axios
      .delete(`${process.env.REACT_APP_BASE_URL}/uom/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};
